// extracted by mini-css-extract-plugin
module.exports = {"ratingStar":"ratingStarSvg-module__ratingStar--1lvbT"};